import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

const ContentfulWebFormStyles = styled.div`
  .buttons {
    > div {
      width: 100%;
      margin-bottom: 10px;
    }
    .button-disabled-container {
      &:hover {
        cursor: not-allowed;
      }
    }
  }
  .disclaimer-checkbox,
  .written-consent-checkbox {
    margin-bottom: 20px;
  }
  p.disclaimer-text {
    font-size: 12px;
  }
  .form-error.disclaimer {
    color: ${Colors.accent.ladyBug.highContrast};
    font-size: 12px;
    padding-bottom: 10px;
  }
  p.sms-disclaimer {
    margin-top: -32px;
    margin-left: 32px;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 17px;
  }
`;

export default ContentfulWebFormStyles;
